import toast from 'react-hot-toast';
import { store } from 'store';
import { closeSnackbar } from 'store/slices/snackbar';

let sessionExpiredPopupOpen = false;

export function isSessionExpiredPopupOpen() {
  return sessionExpiredPopupOpen;
}

export function setSessionExpiredPopupOpen(open) {
  sessionExpiredPopupOpen = open;
  if (open) {
    toast.dismiss();
    store.dispatch(closeSnackbar());
  }
}
